import { MusePeer } from '@/services/RoomContextMusePeer'

export const classifyAndSortPeers = (peers: MusePeer[], galleryClientOrdering: string[] | null) => {
    let normalPeers: MusePeer[] = []
    let listenOnlyPeers: MusePeer[] = []

    Object.entries(peers).filter(([_, peer]) => {
        if (peer.manifest?.clientType === 'listenonly') {
            listenOnlyPeers.push(peer)
        } else {
            normalPeers.push(peer)
        }
    })

    // sort `normalPeers` by `roomState.galleryClientOrdering`
    normalPeers.sort((a, b) => {
        const aIndex = (galleryClientOrdering || []).indexOf(a.sessionId)
        const bIndex = (galleryClientOrdering || []).indexOf(b.sessionId)
        if (aIndex === -1 && bIndex === -1) return 0
        if (aIndex === -1) return 1
        if (bIndex === -1) return -1
        return aIndex - bIndex
    })

    return { normalPeers, listenOnlyPeers }
}
